import p from "./getCmapiCookiePrivacyValue.mjs";
const i = () => {
  var e;
  return ((e = p()) == null ? void 0 : e.split(" ")[1].split(",").map((t) => Number(t))) ?? [
    1
  ];
};
export {
  i as default
};
